import React from "react";
import { SharedMarketPlaceWhatsappMessages } from "@app/shared";

const MarketPlaceWhatsappMessageList: React.FC = () => {
  return <SharedMarketPlaceWhatsappMessages />;
};

export default MarketPlaceWhatsappMessageList;
